import { Link } from 'react-router-dom';

const footerLinks = {
  content: {
    title: '内容分类',
    links: [
      { label: 'ASMR音频', path: '/category/asmr-audio' },
      { label: '沉浸式声景', path: '/category/immersive-soundscape' },
      { label: '耳机推荐', path: '/category/earphone-recommend' },
      { label: '耳骚技巧', path: '/category/ersao-tips' },
      { label: '声音疗愈', path: '/category/sound-healing' },
    ],
  },
  about: {
    title: '关于我们',
    links: [
      { label: '品牌故事', path: '/about' },
      { label: '联系我们', path: '/about#contact' },
      { label: '口碑评价', path: '/about#reputation' },
    ],
  },
  legal: {
    title: '法律信息',
    links: [
      { label: '隐私政策', path: '/about' },
      { label: '使用条款', path: '/about' },
    ],
  },
};

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link
              to="/"
              className="text-2xl font-bold font-heading text-background-50 hover:text-primary-300 transition-colors whitespace-nowrap"
            >
              耳骚
            </Link>
            <p className="mt-3 text-sm text-background-300 leading-relaxed">
              让耳朵沉迷的极致听觉体验平台。
              <br />
              ASMR音频 · 沉浸式声景 · 耳机推荐
            </p>
          </div>

          {Object.values(footerLinks).map((section) => (
            <div key={section.title}>
              <h4 className="text-sm font-semibold text-background-50 mb-4 font-heading">
                {section.title}
              </h4>
              <ul className="space-y-2">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-300 hover:text-primary-300 transition-colors whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-6 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">
            &copy; {new Date().getFullYear()} 耳骚 ErSao. 保留所有权利。
          </p>
          <div className="flex items-center gap-4">
            <a
              href="#"
              className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700/50 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
              aria-label="微博"
            >
              <i className="ri-weibo-line text-sm"></i>
            </a>
            <a
              href="#"
              className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700/50 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
              aria-label="微信"
            >
              <i className="ri-wechat-line text-sm"></i>
            </a>
            <a
              href="#"
              className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700/50 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer"
              aria-label="B站"
            >
              <i className="ri-bilibili-line text-sm"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}